import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../components/AtiraIcon";
import { FontSize } from "../../../../components/Text";
import i18n from "../../../../i18n";
import { AppLangs } from "../../../../model/shared/enum/AppLangs.enum";
import { Shadow } from "../../../../theme/Shadow";
import { Spacing } from "../../../../theme/Spacing";
import { SetupCardEyebrow } from "./DashboardSetupCard";

const Ribbon = styled.span<{ $rtl: boolean }>`
  position: absolute;
  top: 1.75rem;
  ${({ $rtl }) => ($rtl ? "left" : "right")}: -2.9rem;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${Spacing.xs};
  width: 11rem;
  padding-block: 0.375rem;
  transform: rotate(${({ $rtl }) => ($rtl ? "-45deg" : "45deg")});
  background-color: ${({ theme }) => theme.success};
  color: ${({ theme }) => theme.white};
  box-shadow: ${Shadow.SM};
  font-size: ${FontSize.s};
  font-weight: bold;
  /* Spacing letters apart breaks the joins in Arabic script */
  letter-spacing: ${({ $rtl }) => ($rtl ? "normal" : "0.06em")};
  text-transform: uppercase;
  pointer-events: none;
`;

type DashboardSetupCardLabelProps = {
  featured?: boolean;
  done?: boolean;
};

export const DashboardSetupCardLabel: React.FC<
  DashboardSetupCardLabelProps
> = ({ featured, done }) => {
  const { t } = useTranslation();

  if (done) {
    return (
      <Ribbon $rtl={i18n.language === AppLangs.AR}>
        <AtiraIcon icon={faCheck} size="xs" />
        {t("dashboard.setup.done_label")}
      </Ribbon>
    );
  }

  return featured ? (
    <SetupCardEyebrow>{t("dashboard.setup.next_step")}</SetupCardEyebrow>
  ) : null;
};
